<div
    class="flex flex-col w-full justify-between items-center border-2 border-primary rounded-xl absolute bg-p-content-background p-1 z-20"
    [ngStyle]="{
        'height.px': tileHeight,
    }">
    <p-button
        [buttonProps]="{ autofocus: false }"
        (click)="onClickBookSession($event)"
        severity="primary"
        [label]="booking ? '' : 'Book'"
        styleClass="w-full"
        [loading]="booking"
        class="w-full" />
    <p-button
        [buttonProps]="{ autofocus: false }"
        (click)="onClickClearSelectedSession($event)"
        label="Clear"
        [outlined]="true"
        severity="primary"
        styleClass="w-full"
        [disabled]="booking"
        class="w-full" />
</div>
